import React, { Component } from 'react';
import { WINDOW_SIZES } from 'src/constants/main';
import { productsStore } from 'src/mobx/productsStore';
import { ICategory } from 'src/types/products';
import ResponsiveContent from 'src/view/components/ResponsiveContent/ResponsiveContent';
import CategoriesDropDown from './components/CategoriesDropDown/CategoriesDropDown';
import { CategoriesList } from './components/CategoriesList/CategoriesList';
import './style.scss';

class MenuCategories extends Component {
  selectCategory = (category: ICategory) => {
    productsStore.setCategory(category.id);
  };

  render() {
    return (
      <div className="d-flex flex-row justify-content-between full-width  menu-categories">
        <div className={'menu-categories-list mx-n3 hide-scrollbar'}>
          <CategoriesList />
        </div>
        <ResponsiveContent min={WINDOW_SIZES.md}>
          <CategoriesDropDown />
        </ResponsiveContent>
      </div>
    );
  }
}

export default MenuCategories;
